import { render, staticRenderFns } from "./Imobiliaria.vue?vue&type=template&id=4753d644&"
import script from "./Imobiliaria.vue?vue&type=script&lang=js&"
export * from "./Imobiliaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports